import React from 'react';
import { Upload, Button } from 'antd';
import { PaperClipOutlined, DeleteOutlined, FilePdfOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { T, SECTION_LABEL, FIELD_HINT } from './declarationTheme';
import GedFileField from '../../../components/GedFileField';

const estPdf = (file) => file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');

/* Bloc « Pièces jointes » - étape Récapitulatif, sinistre TE uniquement.
   Le dossier TE est enregistré à partir de la fiche de déclaration envoyée par le
   bureau homologue : c'est elle qui porte la demande de confirmation de garantie
   adressée à la compagnie. Elle est donc obligatoire pour déclarer.

   Les fichiers vivent dans l'état du formulaire parent, pas dans le brouillon :
   un fichier ne se sérialise pas. Après un rechargement de la page, il faut les
   joindre à nouveau. */
export default function PiecesHomologueBlock({ pieces, onChange }) {
  const { t } = useTranslation('declaration');
  const { fiche, autres } = pieces;

  const ajouterAutre = (file) => {
    if (!estPdf(file)) {
      toast.error(t('piecesHomologue.formatNonAccepte'));
      return Upload.LIST_IGNORE;
    }
    onChange({ ...pieces, autres: [...autres, file] });
    return false;
  };

  const retirerAutre = (index) => onChange({ ...pieces, autres: autres.filter((_, i) => i !== index) });

  return (
    <div
      style={{
        marginTop: 20,
        padding: '20px 22px',
        background: T.paper,
        border: `1px solid ${fiche ? T.line : '#fcd34d'}`,
        borderRadius: T.r.md,
      }}
    >
      <div style={SECTION_LABEL}>{t('piecesHomologue.titre')}</div>

      <div style={{ fontSize: 13.5, fontWeight: 600, color: T.ink, marginBottom: 4 }}>
        {t('piecesHomologue.fiche')} <span style={{ color: '#dc2626' }}>*</span>
      </div>
      <div style={{ ...FIELD_HINT, marginTop: 0, marginBottom: 12 }}>
        {t('piecesHomologue.ficheAide')}
      </div>
      <GedFileField
        value={fiche}
        onChange={(f) => onChange({ ...pieces, fiche: f })}
        required
        hint={t('piecesHomologue.ficheClassee')}
      />

      <div style={{ fontSize: 13.5, fontWeight: 600, color: T.ink, marginTop: 20, marginBottom: 8 }}>
        {t('piecesHomologue.autresPieces')} <span style={{ ...FIELD_HINT, fontWeight: 400 }}>{t('piecesHomologue.facultatif')}</span>
      </div>
      {autres.map((f, i) => (
        <div key={`${f.name}-${i}`} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, marginBottom: 6 }}>
          <FilePdfOutlined style={{ color: '#dc2626' }} />
          <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</span>
          <Button type="text" size="small" danger icon={<DeleteOutlined />} onClick={() => retirerAutre(i)} aria-label={t('piecesHomologue.retirerFichier', { nom: f.name })} />
        </div>
      ))}
      <Upload beforeUpload={ajouterAutre} showUploadList={false} multiple accept=".pdf,application/pdf">
        <Button icon={<PaperClipOutlined />} size="small">{t('piecesHomologue.ajouterPiece')}</Button>
      </Upload>
    </div>
  );
}
